import ScaleLine from '../control/ScaleLine.js';
import getDPI from './getDPI.js';

function getResFromScale(scale, center, projection, mymap, resolution) {
    const res1 = new ScaleLine();

    var dpi = getDPI();
    res1.setDpi(dpi);

    var scaleResolution = res1.getResolutionForScale(scale, center, projection, mymap, resolution);
    return scaleResolution;
}

export default getResFromScale;
